import { alpha } from "@mui/material";
import { textTransform } from "@mui/system";

const styles = (theme) => ({
  tile: {
    display: "flex",
    alignItems: "center",
    gap: 1.2,
    padding: "8px 12px",
    borderRadius: "12px",
    cursor: "pointer",
    borderStyle: "solid",
    borderWidth: "1.5px",
    borderColor: "transparent",
    transition: "border-color .15s ease, background-color .15s ease",
    backgroundColor:
      theme.palette.mode === "dark"
        ? theme.palette.background.modalContrast
        : theme.palette.colors.black.lighter,
    "&:hover": {
      borderColor: alpha(theme.palette.primary.main, 0.4),
    },
  },
  tileActive: {
    borderColor: theme.palette.primary.main,
    backgroundColor: alpha(theme.palette.primary.main, 0.08),
  },
  iconWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "34px",
    height: "34px",
    borderRadius: "10px",
    flexShrink: 0,
    overflow: "hidden",
  },
  iconImage: {
    width: "20px",
    height: "20px",
    objectFit: "contain",
  },
  icon: {
    fontSize: "19px",
    color: theme.palette.white.main,
  },
  iconFallback: {
    fontSize: "0.7rem",
    fontWeight: "bold",
    color: theme.palette.white.main,
  },
  info: {
    display: "flex",
    flexDirection: "column",
    minWidth: 0,
    flex: 1,
  },
  label: {
    fontWeight: 600,
    fontSize: "0.82rem",
    lineHeight: 1.2,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    textTransform: "capitalize",
  },
  description: {
    fontSize: "0.7rem",
    color: theme.palette.text.secondary,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
});

export default styles;
